<!-- 项目中心 -->
<template>
  <div class="project">
    <div class="container">
      <!-- 面包屑 -->
      <div class="bread">
        <span class="bread-tab">项目中心</span>
      </div>
      <!-- 内容 -->
      <div class="show-box">
        <div class="show-search">
          <!-- 搜索 -->
          <div class="search-item">
            <span class="search-label">项目单位区域：</span>
            <el-cascader
              v-model="dataForm.area"
              :props="{ checkStrictly: true }"
              :options="arealist"
              clearable
              size="small"
              placeholder="请选择区域"
              @change="handleChange"
            ></el-cascader>
          </div>
          <div class="search-item">
            <span class="search-label">项目名称：</span>
            <el-input
              class="search-form"
              size="small"
              clearable
              v-model="dataForm.projectName"
              placeholder="请输入项目名称搜索"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">单位名称：</span>
            <el-input
              class="search-form"
              size="small"
              clearable
              v-model="dataForm.enterpriseNameLike"
              placeholder="请输入单位名称搜索"
            ></el-input>
          </div>
          <!-- <div class="search-item">
            <span class="search-label">单位名称：</span>
            <el-autocomplete
              class="search-form"
              size="small"
              clearable
              v-model="enterpriseValue"
              :trigger-on-focus="false"
              :fetch-suggestions="enterprise_querySearchAsync"
              placeholder="请输入单位名称模糊搜索"
              @select="enterprise_handleSelect"
            ></el-autocomplete>
          </div>-->
          <div class="search-item">
            <span class="search-label">项目类型：</span>
            <el-select
              class="search-form"
              size="small"
              clearable
              v-model="dataForm.status"
              placeholder="请选择项目类型"
            >
              <el-option
                v-for="(item,index) of statuslist"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="search-label">发布时间：</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="starttime"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <span class="content-date-interval">至</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="endtime"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
          <div class="search-item">
            <el-button class="oper-button" type="primary" @click="setDataSort(1)">按时间排序<i class="el-icon-sort-up el-icon--right"></i></el-button>
            <el-button class="oper-button" type="primary" @click="setDataSort(2)">按行政区划排序<i class="el-icon-sort-up el-icon--right"></i></el-button>
            <el-button class="oper-button" size="small" @click="search()">搜索</el-button>
            <el-button class="oper-button" size="small" @click="reset()">重置</el-button>
            <el-button type="primary" class="oper-button" size="small" @click="exportFile()">导出</el-button>
          </div>
        </div>
        <!-- 数据展示 -->
        <div class="show-data">
          <div class="project-datalist clearfix">
            <div class="project-dataitem">
              <div class="project-item-layout">
                <span class="item-number">{{ chartdataList.postNum || '0' }}</span>
                <span class="item-name">岗位数量</span>
              </div>
            </div>
            <div class="project-dataitem">
              <div class="project-item-layout">
                <span class="item-number">{{ chartdataList.enrollNum || '0' }}</span>
                <span class="item-name">招募数量</span>
              </div>
            </div>
            <div class="project-dataitem">
              <div class="project-item-layout">
                <span class="item-number">{{ chartdataList.joinNum || '0' }}</span>
                <span class="item-name">报名数量</span>
              </div>
            </div>
            <div class="project-dataitem">
              <div class="project-item-layout">
                <span class="item-number">{{ chartdataList.passNum || '0' }}</span>
                <span class="item-name">录取数量</span>
              </div>
            </div>
            <div class="project-dataitem">
              <div class="project-item-layout">
                <span class="item-number">{{ chartdataList.signinNum || '0' }}</span>
                <span class="item-name">报到数量</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="show-table">
          <el-table :data="dataList" stripe size="mini" style="width: 100%; ">
            <el-table-column prop="name" label="项目名称" align="center"></el-table-column>
            <el-table-column prop="catalogName" label="项目类型" align="center"></el-table-column>
            <el-table-column prop="area" label="项目单位区域" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.area == 'null' || scope.row.area == 'nullnullnull'">无</span>
                <span v-else>{{ scope.row.area }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="enterpriseName" label="单位名称" align="center"></el-table-column>
            <el-table-column prop="postNum" label="岗位数" align="center"></el-table-column>
            <el-table-column prop="publishDate" label="发布时间" align="center"></el-table-column>
            <el-table-column prop="enrollNum" label="招募人数" align="center"></el-table-column>
            <el-table-column prop="joinNum" label="报名人数" align="center"></el-table-column>
            <el-table-column prop="passNum" label="录取人数" align="center"></el-table-column>
            <el-table-column prop="signInNum" label="报到人数" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="Details(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <div class="muiltiOpiton"></div>
            <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="listPage.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="listPage.size"
              size="small"
              :total="records"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
      :title="'查看详情'"
      :close-on-click-modal="false"
      :visible.sync="orgVisible"
      :append-to-body="true"
      :modal="true"
      width="70%"
    >
      <div class="orgDetails" ref="shareDom">
        <el-divider content-position="left">单位信息</el-divider>
        <div class="details-item-box">
          <!-- <div class="details-tdlist">
            <span class="details-title">单位LOGO：</span>
            <span class="details-content-logo">
              <div
                v-if="detailsData.logo"
                class="details-recommend-img"
                :style="'background-image:url(' + detailsData.logo + ')'"
              ></div>
              <div v-else class="details-recommend-img">
                <el-image style="height: 100%;background-color: #ccc;">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </span>
          </div>-->
          <div class="details-tdlist">
            <span class="details-title">单位名称：</span>
            <span class="details-content">{{ detailsData.enterprise_name || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位介绍：</span>
            <span class="details-content">{{ detailsData.company_profile || '无'}}</span>
          </div>
          <!-- <div class="details-tdlist">
            <span class="details-title">单位地址：</span>
            <span class="details-content">{{ detailsData.address || '无'}}</span>
          </div>-->
          <div class="details-tdlist">
            <span class="details-title">单位（项目）区域：</span>
            <span class="details-content project-arealist">
              <template v-if="detailsData.areaList && detailsData.areaList.length > 0">
                <li class="project-arealist-item"
                  v-for="(item,index) of detailsData.areaList"
                  :key="index"
                >{{ item | returnArealist(index) }}</li>
              </template>
              <span v-else>无</span>
            </span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">项目联系人：</span>
            <span class="details-content project-arealist">
              <template v-if="detailsData.contactList && detailsData.contactList.length > 0">
                <li class="project-contact-item" v-for="(item,index) of detailsData.contactList" :key="index">
                  <span>{{ item.contactName + '&nbsp;(联系方式：' + item.contactTel + ')' }}</span>
                </li>
              </template>
              <span v-else>无</span>
            </span>
          </div>
        </div>
        <el-divider content-position="left">项目信息</el-divider>
        <div class="details-item-box">
          <div class="details-tdlist">
            <span class="details-title">项目（岗位）名称：</span>
            <span class="details-content">{{ detailsData.name || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">项目（岗位）介绍：</span>
            <span class="details-content">{{ detailsData.content || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">项目标签：</span>
            <span class="details-content">{{ detailsData.catalog_name || '无'}}</span>
          </div>
          <!-- <div class="details-tdlist">
            <span class="details-title">所属专题：</span>
            <span class="details-content">{{ detailsData.topicName || '无'}}</span>
          </div>-->
          <!-- <div class="details-tdlist">
            <span class="details-title">项目（岗位）图片：</span>
            <span class="details-content">
              <div
                v-if="detailsData.imgList && detailsData.imgList != null && detailsData.imgList.length > 0 "
              >
                <div class="details-img" v-for="(item,index) of detailsData.imgList" :key="index">
                  <el-image
                    style="width: 100%; height:100% ;"
                    :src="item.url"
                    :preview-src-list="[item.url]"
                  >
                    <div
                      slot="error"
                      class="image-slot"
                      style="text-align:center;width:100%;height:100%;line-height:150px;background-color:#f2f2f2;font-size: 24px;"
                    >
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
              <span v-else>暂无图片</span>
            </span>
          </div>-->
          <div class="details-tdlist">
            <span class="details-title">参与须知：</span>
            <span class="details-content">{{ detailsData.join_tip || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">报名时间：</span>
            <span
              class="details-content"
            >{{ (detailsData.join_start_date || '--') + ' 至 ' + (detailsData.join_end_date || '--') }}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">项目时间（预估）：</span>
            <span
              class="details-content"
            >{{ (detailsData.start_date || '--') + ' 至 ' + (detailsData.end_date || '--') }}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">最大报名人数：</span>
            <span
              class="details-content"
              v-if="detailsData.join_max_num != -1"
            >{{ detailsData.join_max_num || '0'}}&nbsp;人</span>
            <span class="details-content" v-else>人数不限</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">招募人数：</span>
            <span class="details-content">{{ detailsData.enroll_num || '0'}}&nbsp;人</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">岗位设置：</span>
            <span class="details-content">
              <div class="post-wrap" v-if="postUnitList.length > 0">
                <ul class="post-ul" v-if="list.postUnitList && list.postUnitList.length > 0">
                  <li class="post-name">- 单位 -</li>
                  <li
                    v-for="(item,index) in postUnitList"
                    @click="handleFocus(index, 'unit')"
                    :class="[index == currentUnitIndex ? 'active' : '', 'post-li']"
                    :key="index"
                  >
                    <span>{{item.postUnitName}}</span>
                  </li>
                </ul>
                <ul
                  class="post-ul"
                  v-if="(list.postUnitList && list.postUnitList.length > 0) || (list.postDeparmentList && list.postDeparmentList.length > 0)"
                >
                  <li class="post-name">- 部门 -</li>
                  <li
                    v-for="(item,index) in postUnitList[currentUnitIndex].postDeparmentList"
                    @click="handleFocus(index, 'depa')"
                    :class="[index == currentDepaIndex ? 'active' : '', 'post-li']"
                    :key="index"
                  >
                    <span>{{item.name}}</span>
                  </li>
                </ul>
                <ul class="post-ul">
                  <li class="post-name">- 岗位 -</li>
                  <li
                    class="post-li"
                    v-for="(item,index) in postUnitList[currentUnitIndex].postDeparmentList[currentDepaIndex].postoptions"
                    :key="index"
                  >
                    <span>{{item.name}}</span>
                  </li>
                </ul>
              </div>
            </span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位福利：</span>
            <span class="details-content">{{ detailsData.welfare | returnWelfare }}</span>
          </div>
        </div>
        <el-divider content-position="left">附件信息</el-divider>
        <div class="details-item-box">
          <!-- <div class="details-tdlist">
            <span class="details-title">自定义报名信息：</span>
            <span
              class="details-content"
              v-if="detailsData.fullList &&detailsData.fullList.length > 0"
            >
              <el-tag
                v-for="(tag, index) in detailsData.fullList"
                :key="index"
                type="success"
                class="pointer"
                size="small"
                :disable-transitions="false"
                v-show="!(tag.delFlag && tag.delFlag === '1')"
                @close="handleClose(tag)"
              >{{tag.name}} {{ tag.must == '1'? '(必填)':'(选填)' }}</el-tag>
            </span>
            <span class="details-content" v-else>暂无信息</span>
          </div>-->
          <div class="details-tdlist">
            <span class="details-title">项目附件：</span>
            <span class="details-content">
              <div
                v-if="detailsData.attachmentList && detailsData.attachmentList != null && detailsData.attachmentList.length > 0 "
              >
                <template v-for="(item,index) of detailsData.attachmentList">
                  <div :key="index" v-if="returnType(item) == 'jpg'">
                    <!-- <el-image
                      style="width: 100%; height:100% ;"
                      :src="item.url"
                      :preview-src-list="[item.url]"
                    >
                      <div
                        slot="error"
                        class="image-slot"
                        style="text-align:center;width:100%;height:100%;line-height:80px;background-color:#f2f2f2;font-size: 24px;"
                      >
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>-->
                    <div style="margin-bottom:10px;">
                      <el-tag size="small" type="success">{{item.filename}}</el-tag>
                      <a :href="item.url" target="_blank" download style="margin-left:5px;">点击查看</a>
                    </div>
                  </div>
                  <template v-else>
                    <div :key="index">
                      <div style="margin-bottom:10px;">
                        <el-tag size="small" type="success">{{item.filename}}</el-tag>
                        <a :href="item.url" target="_blank" download style="margin-left:5px;">点击查看</a>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
              <span v-else>暂无附件</span>
            </span>
          </div>
        </div>
      </div>
        <div class="details-tdlist details-sureBtn">
          <el-button type="primary" size="small" @click="detailsSure()">确定</el-button>
          <el-button type="primary" size="small" @click="clickGeneratePicture()">下载详情图片</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import {downloadExport, UrlUpdateParams} from '@/util/utils'
import { Button, Input, Select, Option, Table, TableColumn, DatePicker, Pagination, Cascader, Autocomplete, Dialog, Divider, Image, Tag } from 'element-ui'
export default {
  components: {
    'el-button': Button,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-date-picker': DatePicker,
    'el-pagination': Pagination,
    'el-cascader': Cascader,
    'el-autocomplete': Autocomplete,
    'el-dialog': Dialog,
    'el-divider': Divider,
    'el-image': Image,
    'el-tag': Tag
  },
  data () {
    return {
      listPage: {
        page: 1,
        size: 20
      },
      orgVisible: false,
      records: 0,
      dataForm: {
        sort: 1,
        area: '',
        status: '',
        date: '',
        projectName: '',
        enterpriseId: '',
        enterpriseNameLike: '',
        provinceId: '',
        cityId: '',
        areaId: ''
      },
      statuslist: [],
      dataList: [],
      chartdataList: {},
      arealist: [], // 省市区存储数据
      // 单位模糊搜索参数
      enterpriseValue: '',
      entervS: [],
      detailsData: {},
      list: [],
      postUnitList: [],
      currentUnitIndex: 0,
      currentDepaIndex: 0,
      starttime: null,
      endtime: null
    }
  },
  filters: {
    returnArealist (item, index) {
      let areatext = '(' + (index + 1) + ') '
      if (item.provinceName && item.provinceName !== null) {
        areatext += item.provinceName
      }
      if (item.cityName && item.cityName !== null) {
        areatext += '-'
        areatext += item.cityName
      }
      if (item.areaName && item.areaName !== null) {
        areatext += '-'
        areatext += item.areaName
      }
      return areatext
    },
    returnWelfare (val) {
      if (val === '' || val === null || val === undefined) {
        return '暂无'
      } else {
        var newText = ''
        var itemIndexlist = val.split(',')
        itemIndexlist.forEach((item, index) => {
          if (item === '1' || item === 1) {
            newText += '提供住宿'
            if (index < (itemIndexlist.length - 1)) {
              newText += '，'
            }
          } else if (item === '2' || item === 2) {
            newText += '提供保险'
            if (index < (itemIndexlist.length - 1)) {
              newText += '，'
            }
          } else if (item === '3' || item === 3) {
            newText += '提供伙食补助'
            if (index < (itemIndexlist.length - 1)) {
              newText += '，'
            }
          } else if (item === '4' || item === 4) {
            newText += '提供工资'
            if (index < (itemIndexlist.length - 1)) {
              newText += '，'
            }
          } else if (item === '5' || item === 5) {
            newText += '提供其他补贴'
            if (index < (itemIndexlist.length - 1)) {
              newText += '，'
            }
          }
        })
        return newText
      }
    }
  },
  watch: {
    // 单位模糊搜索
    enterpriseValue (val) {
      var _this = this
      var csvList = []
      if (val === '') {
        _this.dataForm.enterpriseId = ''
      }
      _this.entervS = []
      _this.getEnterprise(val, (list) => {
        if (list == null || list === '' || list === undefined) {
          if (val !== '') {
            _this.$message.info('暂无该单位')
          }
        } else {
          csvList = list
          var arr = []
          for (let i = 0; i < csvList.length; i++) {
            if (csvList[i].enterpriseName.indexOf(val) >= 0) {
              arr.push(csvList[i])
            }
          }
          for (let i = 0; i < arr.length; i++) {
            var obj = { value: '', id: '' }
            obj.value = arr[i].enterpriseName
            obj.id = arr[i].enterpriseId
            _this.entervS.push(obj)
          }
        }
      })
    }
  },
  created () {
    // 获取省市区三级联动数据
    this.getAreainfo((res) => {
      this.arealist = res
    })
    // 获取项目类型
    this.$http({
      method: 'post',
      url: '/project_catalog'
    }).then(res => {
      if (res.code === 100) {
        this.statuslist = res.result
        this.records = res.records
      }
    }).catch(error => {
      console.log(error)
      return false
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    setDataSort (val) {
      this.dataForm.sort = val
      this.listPage.page = 1
      this.init()
    },
    init (type) {
      if (type && type === 'search') {
        this.listPage.page = 1
      }
      // if (this.dataForm.enterpriseId === '') {
      //   this.enterpriseValue = ''
      // }
      let data = {
        // enterpriseId: this.dataForm.enterpriseId || '',
        enterpriseNameLike: this.dataForm.enterpriseNameLike || '',
        provinceId: this.dataForm.provinceId || '',
        cityId: this.dataForm.cityId || '',
        areaId: this.dataForm.areaId || '',
        catalogId: this.dataForm.status || '',
        name: this.dataForm.projectName || '',
        starttime: this.starttime ? `${this.starttime} 00:00:00` : "",
        endtime: this.endtime ? `${this.endtime} 23:59:59` : "",
        pagesize: this.listPage.size,
        page: this.listPage.page,
        sort: this.dataForm.sort
      }
      // 请求图表内容
      this.$http({
        method: 'post',
        url: '/project_center_num',
        params: data
      }).then(res => {
        if (res.code === 100) {
          this.chartdataList = res.result
        }
      }).catch(error => {
        console.log(error)
        return false
      })
      // 请求列表内容
      this.$http({
        method: 'post',
        url: '/project_center_list',
        params: data
      }).then(res => {
        if (res.rows) {
          this.dataList = res.rows
          this.records = res.records
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    // 搜索按钮
    search () {
      this.init('search')
    },
    // 重置按钮
    reset () {
      Object.assign(this.$data.dataForm, this.$options.data().dataForm)
      this.starttime = null
      this.endtime = null
      this.enterpriseValue = ''
      this.init('search')
    },
    // 修改列表展示条数时调用
    sizeChangeHandle (val) {
      this.listPage.size = val
      this.init('search')
    },
    // 页码改变时触发
    currentChangeHandle (val) {
      this.listPage.page = val
      this.init()
    },
    // 查看详情
    Details (row) {
      this.$http({
        method: 'post',
        url: '/project_detail',
        params: {
          projectId: row.projectId
        }
      }).then(res => {
        if (res.code === 100) {
          this.detailsData = res.result
          this.list = this.formatPostSetting()
          if (this.list.postUnitList && this.list.postUnitList.length > 0) {
            this.postUnitList = this.list.postUnitList
          } else if (this.list.postDeparmentList && this.list.postDeparmentList.length > 0) {
            this.postUnitList = [{
              postDeparmentList: this.list.postDeparmentList,
              postUnitName: ''
            }]
          } else {
            this.postUnitList = [{
              postDeparmentList: [{
                name: '',
                postoptions: this.list.postoptions
              }],
              postUnitName: ''
            }]
          }
          this.orgVisible = true
        } else {
          this.$message.info(res.msg || res.result.msg)
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    // 详情 岗位设置数据初始化
    formatPostSetting () {
      let originList = []
      let postType = 1
      let _ = this
      let list = {
        postUnitList: [],
        postDeparmentList: [],
        postoptions: []
      }
      if (_.detailsData.postSetting.departlist.length > 0) {
        originList = [..._.detailsData.postSetting.departlist]
        postType = 2
      } else if (_.detailsData.postSetting.postList.length > 0) {
        originList = [..._.detailsData.postSetting.postList]
        postType = 1
      } else if (_.detailsData.postSetting.unitList.length > 0) {
        originList = [..._.detailsData.postSetting.unitList]
        postType = 3
      }
      let currentItem = {}
      let currentcItem = {}
      let currentgItem = {}
      originList.forEach(item => {
        if (postType === 3) {
          currentItem = {
            postUnitName: item.name,
            postDeparmentList: []
          }
          item.childList.forEach(cItem => {
            currentcItem = {
              name: cItem.name,
              postoptions: []
            }
            cItem.childList.forEach(gItem => {
              currentgItem = {
                name: gItem.name
              }
              currentcItem.postoptions.push(currentgItem)
            })
            currentItem.postDeparmentList.push(currentcItem)
          })
          list.postUnitList.push(currentItem)
        } else if (postType === 2) {
          currentItem = {
            name: item.name,
            postoptions: []
          }
          item.childList.forEach(cItem => {
            currentcItem = {
              name: cItem.name
            }
            currentItem.postoptions.push(currentcItem)
          })
          list.postDeparmentList.push(currentItem)
        } else {
          currentItem = {
            name: item.name
          }
          list.postoptions.push(currentItem)
        }
      })
      return list
    },
    // 岗位设置（单位，部门）点击事件
    handleFocus (index, type) {
      if (type === 'unit') {
        this.currentUnitIndex = index
        this.currentDepaIndex = 0
      } else if (type === 'depa') {
        this.currentDepaIndex = index
      }
      this.$forceUpdate()
    },
    // 关闭详情
    detailsSure () {
      this.orgVisible = false
      this.detailsData = {}
    },
    // 省市区三级联动选择事件
    handleChange (item) {
      this.dataForm.provinceId = item[0] || ''
      this.dataForm.cityId = item[1] || ''
      this.dataForm.areaId = item[2] || ''
    },
    // 单位模糊搜索选择事件
    enterprise_querySearchAsync (queryString, cb) {
      var csvS = this.entervS
      cb(csvS)
    },
    enterprise_handleSelect (item) {
      this.dataForm.enterpriseId = item.id
    },
    // 判断类型格式
    returnType (res) {
      if (res.mimetype != null && (res.mimetype.indexOf('image') !== -1 || res.mimetype.indexOf('jpeg') !== -1)) {
        return 'jpg'
      } else {
        return 'word'
      }
    },
    // 保存图片
    saveFileM (Url, filename) {
      var blob = new Blob([''], { type: 'application/octet-stream' })
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = Url
      a.download = filename || this.detailsData.name + '.jpg'
      var e = document.createEvent('MouseEvents')
      e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
      URL.revokeObjectURL(url)
    },
    // 生成图片
    clickGeneratePicture () {
      this.$alert('图片已经开始下载，请稍候..', {
        type: 'success',
        confirmButtonText: '确定'
      })
      html2canvas(this.$refs.shareDom).then(canvas => {
        // 转成图片，生成图片地址
        this.imgUrl = canvas.toDataURL('image/png', 1) // 可将 canvas 转为 base64 格式
        this.saveFileM(this.imgUrl.replace('image/jpeg', 'image/octet-stream'))
      })
    },
    // 导出
    exportFile () {
      let params = {
        enterpriseNameLike: this.dataForm.enterpriseNameLike || '',
        provinceId: this.dataForm.provinceId || '',
        cityId: this.dataForm.cityId || '',
        areaId: this.dataForm.areaId || '',
        catalogId: this.dataForm.status || '',
        name: this.dataForm.projectName || '',
        starttime: this.starttime ? `${this.starttime} 00:00:00` : "",
        endtime: this.endtime ? `${this.endtime} 23:59:59` : "",
        sort: this.dataForm.sort
      }
      let downURL = UrlUpdateParams('/api/project_center_list/export', params)
      const loading = this.$loading({
        lock: true,
        text: '处理中 ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.35)'
      })
      downloadExport(downURL, loading)
    }
  }
}
</script>
<style src='./project.scss' lang="scss" scoped></style>
<style lang="scss" scoped>
.content-date-item {
  display: inline-block;

  >>> .el-input--suffix {
    .el-input__inner {
      padding-left: 32px;
    }
  }
}
.content-date-interval {
  padding: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/project.vue